<template>
  <h2 class="sub-title">Pick your game to load the rules below</h2>
  <div
    id="games-tabs"
    class="flex flex-row gap-[10px] border-b-1 border-t-1 pt-4 border-white pb-4 w-full"
    draggable="true"
    aria-label="Draggable horizontal content"
  >
    <ButtonToggle
      :data-index="index + 1"
      class="py-4 px-8 games-tab"
      v-for="(tab, index) in $options.computed.tabsPlaceholder"
      :key="`tab${index}`"
      :active="activeTabIndex === index"
      @click="setActiveTab(index, tab.$props.fields.title)"
    >
      <sc-text :field="tab.$props.fields.title" />
    </ButtonToggle>
  </div>

  <div class="primary-border-wrapper rounded-xl" id="game-details">
    <div className="bg-primary-dark rounded-xl p-4">
      <component :is="activeTab" />
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import { Text } from '@sitecore-jss/sitecore-jss-vue';
import ButtonToggle from './ButtonToggle.vue';
import { gtmEvent } from '../utils/analytics';
export default {
  name: 'GamesTabs',
  components: {
    ScText: Text,
    ButtonToggle,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup() {
    function scroller() {
      const scroller = document.getElementById('games-tabs');
      scroller.addEventListener('click', (e) => {
        const btn = e.target.closest('button');
        if (!btn || !scroller.contains(btn)) return;
        const dataIndex = btn?.parentElement?.getAttribute('data-index');
        if (dataIndex == 2) {
          const scrollerWidth = scroller.offsetWidth;
          let scrollDistance = (scrollerWidth - 236) / 2;
          let xOffset = -scrollDistance;
          let x = btn.getBoundingClientRect().left + window.scrollX + xOffset;
          if (btn.getBoundingClientRect().left < 0) {
            //if we're moving to the right
            xOffset = scrollDistance;
            x = btn.getBoundingClientRect().right + window.scrollX + xOffset;
          }
          scroller.scrollTo({ left: x, behavior: 'smooth' });
        } else {
          // Scroll only as much as needed, both axes
          btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      });
    }

    onMounted(() => {
      scroller();
    });
  },
  methods: {
    setActiveTab(index, tabName) {
      this.activeTabIndex = index;
      const gameDetails = document.getElementById('game-details');
      if (gameDetails) {
        setTimeout(() => {
          const y = gameDetails.getBoundingClientRect().top + window.scrollY - 20;
          window.scroll({
            top: y,
            behavior: 'smooth',
          });
        }, 250);
      }
    },
  },
  data() {
    return {
      activeTabIndex: 0,
    };
  },
  withPlaceholder() {
    return {
      placeholders: [
        {
          placeholder: 'jss-tabs',
          computedPropName: 'tabsPlaceholder',
        },
      ],
    };
  },
  computed: {
    activeTab() {
      const tab =
        this.$options.computed.tabsPlaceholder &&
        this.$options.computed.tabsPlaceholder[this.activeTabIndex];
      return tab;
    },
  },
  watch: {
    activeTab(newVal, oldVal) {
      gtmEvent('down_under_games', {
        Tab: this.$options.computed.tabsPlaceholder[this.activeTabIndex].$props.fields.title,
      });
    },
  },
};
</script>
